// Layout rules for the game screen (components/playGame/GameScreen.vue).
// The live game and the replay both use that screen, so these rules apply to both.

// Which panel is shown in which phase.
export const ELEMENT_VIEW_PHASES = Object.freeze({
  playersBox: ["JOIN", "READ"],
  focusGroupBox: ["PRELIMINARY_VOTE", "DISCUSS", "VOTE", "REVEAL", "DEBRIEF"],
  playersCountBox: ["PRELIMINARY_VOTE", "DISCUSS", "VOTE", "REVEAL", "DEBRIEF"],
  hostGameTextsBox: ["JOIN", "READ", "PRELIMINARY_VOTE", "DISCUSS", "VOTE", "DEBRIEF"],
  playerGameTextsBox: ["READ", "PRELIMINARY_VOTE", "DISCUSS", "VOTE", "DEBRIEF"],
  prelimVotesDisplayBox: ["DISCUSS"],
  hostGameChatBox: ["DISCUSS", "VOTE", "DEBRIEF"],
  playerGameChatBox: ["DISCUSS", "VOTE", "DEBRIEF"],
  gamePrelimVoteBox: ["PRELIMINARY_VOTE"],
  gameVoteBox: ["VOTE"],
  gameTextsVoteBox: ["DISCUSS"],
  topResultsBox: ["REVEAL"],
  leaderboardBox: ["REVEAL", "DEBRIEF"],
  textVotesBox: ["REVEAL", "DEBRIEF"],
  saboteurVotesBox: ["REVEAL", "DEBRIEF"],
  gameTextsVoteTabButton: ["DISCUSS"],
  gameTextsTabButton: ["DISCUSS", "DEBRIEF"],
  prelimVotesDisplayTabButton: ["DISCUSS"],
  leaderboardTabButton: ["REVEAL", "DEBRIEF"],
  textVotesTabButton: ["REVEAL", "DEBRIEF"],
  saboteurVotesTabButton: ["REVEAL", "DEBRIEF"],
  startGameButton: ["JOIN"],
  continueGameButton: ["READ", "PRELIMINARY_VOTE", "DISCUSS", "VOTE", "REVEAL"],
  endGameButton: ["DEBRIEF"],
});

// The tab the live game opens when each phase starts.
const PHASE_START_TAB = Object.freeze({ DISCUSS: "gameTextsVote", REVEAL: "leaderboard", DEBRIEF: "gameTexts" });

export function defaultTabForPhase(phase) {
  return PHASE_START_TAB[phase] || "gameTexts";
}
